import React from 'react';
import {Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, Card, CardHeader, CardBody} from 'reactstrap';

class RateSysFormStatusModal extends React.Component {

  constructor(props) {
		super(props);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleCancel = this.handleCancel.bind(this);
		this.handleOkDuplicateClick = this.handleOkDuplicateClick.bind(this);
	}

	render() {
		// console.log("MODAL: render");
		return (
    	<Modal 
  		isOpen={(this.props.showModalOption > 0)} 
    		//toggle={this.props.handleExitStatusModal}		// when clicking outside the modal
    		className={this.props.className} size='sm'>

        <form className="form-horizontal" onSubmit={this.handleSubmit}>
	    		<ModalHeader /*toggle={this.props.handleExitModal}*/>	{/* displays a small X in header */}
     				Confirmation
      		</ModalHeader>

      		<ModalBody>
      			{/* MODAL DE CONFIRMATION */}
      			{(this.props.showModalOption === 1) ?
	      			<div className="row">
	      			<div className="col-md-12">
	      				Votre formulaire de cotation a été soumis avec succès. <br/><br/>
	      				Merci pour votre contribution
	        		</div>
	        		</div>
	        		: null}

      			{/* MODAL DE VALIDATION - FORMULAIRE EN DOUBLE */}
      			{(this.props.showModalOption === 2) ?
	      			<div className="row">
	      			<div className="col-md-12">
	      				<p className="redBoldText">ATTENTION: Vous avez déjà soumis un formulaire pour cette ligue. </p>
	      				<p>Voulez-vous soumettre un nouveau formulaire qui remplacera le précédent ?</p>
	      				<p>(si vous êtes convaincu que c'est votre premier formulaire pour cette ligue, répondez 'Oui' et
	      				contactez Pascal Grenier ou Pat Poulin)</p>
	        		</div>
	        		</div>
	        		: null}
      		</ModalBody>

     			<ModalFooter>
      			{(this.props.showModalOption === 1) ?
	      			<button type="submit" className="btn btn-secondary btn-sm stdCommandButton2"> OK </button>
        		: null}

      			{(this.props.showModalOption === 2) ?
      				<div>
							<button type="button" className="btn btn-primary" 
								onClick={this.handleOkDuplicateClick}>Oui</button>&nbsp;&nbsp;&nbsp;&nbsp;
							<button type="button" className="btn btn-primary"
								onClick={this.handleCancel}>Non</button>
      				</div>
        		: null}
	     		</ModalFooter>
        </form>
    	</Modal>
    )
	}

	handleSubmit(e) {
		e.preventDefault();
		this.props.handleExitStatusModal();
	}

	handleCancel(e) {
		this.props.handleExitStatusModal();
	}

	handleOkDuplicateClick(e) {
		this.props.handleSubmitFormClick(true);
	}

}

export default RateSysFormStatusModal;